var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGitCommitHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-git-commit-horizontal"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  x2: 9,
  y1: 12,
  y2: 12
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 15,
  x2: 21,
  y1: 12,
  y2: 12
})));
export default SvgGitCommitHorizontal;